import ContentLoader from "react-content-loader"
import {useMediaQuery} from "@material-ui/core";

export const  QuestionTextLoader=(props)=> {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
    // if(lg){
        return (
            <ContentLoader
                speed={2}
                width={lg ? 800 : 250}
                height={ lg ? 120 : 80}
                viewBox={ lg ? "0 0 800 100" : "0 0 250 80"}
                backgroundColor="#ede8e8"
                foregroundColor="#c7c7c7"
                {...props}
            >
                <rect x="34" y="30" rx="5" ry="5" width={ lg ? "800" : "250"} height={lg ? "16" : "10" }/>
                <rect x="50" y={ lg ? "70" : "50"} rx="6" ry="6" width={ lg ?"50" : "30"} height={lg ? "16" : "10" }/>

            </ContentLoader>
        )


}

export const PropositionsLoader=(props)=> {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
        return (
            <ContentLoader
                speed={2}
                width={ lg ? 550 : 250}
                height={400}
                viewBox={lg ? "0 0 550 400" : "0 0 250 400"}
                backgroundColor="#ede8e8"
                foregroundColor="#c7c7c7"
                {...props}
            >
                <circle cx="34" cy={ lg ? "59" : "52"} r={lg ? "30" : "15"}/>
                <rect x={lg ? "76" : "60"} y="39" rx="5" ry="5" width={ lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <rect x={lg ? "76" : "60"} y={ lg ? "69": "54"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <circle cx="34" cy={ lg ? "138" : "108"} r={lg ? "30" : "15"}/>
                <rect x={lg ? "76" : "60"} y={ lg ? "118" : "93"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <rect x={lg ? "76" : "60"} y={ lg ?"148" : "108"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <circle cx='34' cy={ lg ? "222" :"162"} r={lg ? "30" : "15"}/>
                <rect x={lg ? "76" : "60"} y={ lg ? "202" : "147"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <rect x={lg ? "76" : "60"} y={ lg ? "232" : "162"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <circle cx="34" cy={lg ? "307" : "216"} r={lg ? "30" : "15"}/>
                <rect x={lg ? "76" : "60"} y={ lg ? "287" : "201"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
                <rect x={lg ? "76" : "60"} y={ lg ? "317" : "216"} rx="5" ry="5" width={lg ? "550" : "250"} height={ lg ? "16" : "10"}/>
            </ContentLoader>
        )

}

export const QuestionTypeLoader=(props)=>(
    <ContentLoader
        speed={2}
        width={50}
        height={50}
        viewBox="0 0 50 50"
        backgroundColor="#ede8e8"
        foregroundColor="#c7c7c7"
        {...props}
    >
        <circle cx="26" cy="29" r="21" />
    </ContentLoader>
)

export const QuestionNameLoader=(props)=> {
    const sm = useMediaQuery('(min-width:576px)');
    const md = useMediaQuery('(min-width:768px)');
    const lg = useMediaQuery('(min-width:992px)');
    const xl = useMediaQuery('(min-width:1200px)');
    if(lg) {
        return (
            <ContentLoader
                speed={2}
                width={400}
                height={40}
                viewBox="0 0 400 40"
                backgroundColor="#ede8e8"
                foregroundColor="#c7c7c7"
                {...props}
            >
                <rect x="5" y="20" rx="5" ry="5" width="400" height="16"/>
            </ContentLoader>
        )
    }else{
        return (
            <ContentLoader
                speed={2}
                width={160}
                height={60}
                viewBox="0 0 160 60"
                backgroundColor="#f3f3f3"
                foregroundColor="#ecebeb"
                {...props}
            >
                <rect x="8" y="7" rx="0" ry="0" width="150" height="15" />
                <rect x="9" y="29" rx="0" ry="0" width="150" height="15" />
                <rect x="41" y="49" rx="0" ry="0" width="75" height="10" />
            </ContentLoader>
        )
    }

};

export const PieChartLoader=(props)=>(
    <ContentLoader viewBox="0 0 400 200" height={200} width={400} {...props}>
        <rect x="100" y="5" rx="0" ry="0" width="200" height="15" />
        <circle cx="140" cy="110" r="70" />
        <rect x="230" y="50" rx="0" ry="0" width="7" height="7" />
        <rect x="250" y="50" rx="0" ry="0" width="30" height="7" />
        <rect x="230" y="64" rx="0" ry="0" width="7" height="7" />
        <rect x="250" y="64" rx="0" ry="0" width="30" height="7" />
        <rect x="230" y="78" rx="0" ry="0" width="7" height="7" />
        <rect x="250" y="78" rx="0" ry="0" width="30" height="7" />
        <rect x="230" y="92" rx="0" ry="0" width="7" height="7" />
        <rect x="250" y="92" rx="0" ry="0" width="50" height="7" />
    </ContentLoader>
)


